<template>
  <div class="filedrop">
    <h3>Drop your files here</h3>
    <div
      @dragenter="fileHover = true"
      @dragleave="fileHover = false"
      @dragover.prevent=""
      @drop.stop.prevent="onDrop"
      class="filedrop-receive"
      :class="{ 'filedrop-receive-hover': fileHover }"
    ></div>
  </div>
</template>

<script lang="ts">
import { Options, Vue } from "vue-class-component";

@Options({
  data() {
    return {
      fileHover: false,
    };
  },
})
export default class FileDrop extends Vue {
  fileHover!: boolean;

  onDrop(e: DragEvent) {
    this.fileHover = false;
    if (!e.dataTransfer) return;
    const { files } = e.dataTransfer;
    const fileArray = [];
    for (let i = 0; i < files.length; i++) {
      fileArray.push(files.item(i));
    }
    this.$emit("files", fileArray);
  }
}
</script>

<style lang="scss">
.filedrop,
.filedrop-receive {
  height: 150px;
  box-sizing: border-box;
}

.filedrop-receive {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  border: 8px solid #aaa;
}

.filedrop {
  position: relative;
  text-align: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin-bottom: 2em;
}

.filedrop-receive.filedrop-receive-hover {
  border-color: #ccffcc;
  background-color: #90f09020;
}

.filedrop h3 {
  font-size: 1.5em;
}
</style>
